var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55 2.35C4.03902 1.69797 4.67314 1.16875 5.40213 0.804257C6.13112 0.439762 6.93496 0.25 7.75 0.25H11.5C12.0967 0.25 12.669 0.487053 13.091 0.90901C13.5129 1.33097 13.75 1.90326 13.75 2.5V12.25C13.75 12.6478 13.592 13.0294 13.3107 13.3107C13.0294 13.592 12.6478 13.75 12.25 13.75H1.75C1.35218 13.75 0.970644 13.592 0.68934 13.3107C0.408035 13.0294 0.25 12.6478 0.25 12.25V7.99975C0.25 7.18836 0.513167 6.39886 1 5.74975L3.55 2.35ZM7.75 1.75C7.16783 1.75 6.59366 1.88554 6.07295 2.1459C5.55224 2.40625 5.0993 2.78426 4.75 3.25L2.5 6.25H12.25V2.5C12.25 2.30109 12.171 2.11032 12.0303 1.96967C11.8897 1.82902 11.6989 1.75 11.5 1.75H7.75ZM9.25 8.5C9.05109 8.5 8.86032 8.57902 8.71967 8.71967C8.57902 8.86032 8.5 9.05109 8.5 9.25C8.5 9.44891 8.57902 9.63968 8.71967 9.78033C8.86032 9.92098 9.05109 10 9.25 10H10C10.1989 10 10.3897 9.92098 10.5303 9.78033C10.671 9.63968 10.75 9.44891 10.75 9.25C10.75 9.05109 10.671 8.86032 10.5303 8.71967C10.3897 8.57902 10.1989 8.5 10 8.5H9.25Z",
    fill: "url(#paint0_linear_5131_13496)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5131_13496",
    x1: 0.25,
    y1: 0.25,
    x2: 14.0252,
    y2: 0.536953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleWindow);
export default __webpack_public_path__ + "static/media/vehicle-window.fe26d1a789962602b65839a349be1462.svg";
export { ForwardRef as ReactComponent };